import { ProjectView, WorkspaceView } from '@lemoncloud/codes-goods-api';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const createDualStorage = () => ({
    getItem: (name: string) => {
        const sessionData = sessionStorage.getItem(name);
        if (sessionData) {
            return JSON.parse(sessionData);
        }

        const localData = localStorage.getItem(name);
        if (localData) {
            return JSON.parse(localData);
        }

        return null;
    },
    setItem: (name: string, value: unknown) => {
        const serializedValue = JSON.stringify(value);
        sessionStorage.setItem(name, serializedValue);
        localStorage.setItem(name, serializedValue);
    },
    removeItem: (name: string) => {
        sessionStorage.removeItem(name);
        localStorage.removeItem(name);
    },
});

interface WorkspaceProjectState {
    workspace: WorkspaceView | null;
    project: ProjectView | null;
    siteId: string | null;
    setWorkspace: (workspace: WorkspaceView | null) => void;
    setProject: (project: ProjectView | null) => void;
    setSiteId: (siteId: string | null) => void;
    clearSelection: () => void;
}

export const useSelectedStore = create<WorkspaceProjectState>()(
    persist(
        set => ({
            workspace: null,
            project: null,
            siteId: null,
            setWorkspace: workspace => set({ workspace }),
            setProject: project => set({ project }),
            setSiteId: siteId => set({ siteId }),
            clearSelection: () => set({ workspace: null, project: null }),
        }),
        {
            name: 'workspace-project-selection',
            storage: createDualStorage(),
        }
    )
);
